import Separator from 'components/common/separator';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import HotelRescheduleItemCard from './card';
import { HotelRescheduleDetailFormType } from '../form-type';

export default function HotelItems() {
  const { control } = useFormContext();
  const hotelSales: HotelRescheduleDetailFormType[] = useWatch({
    control,
    name: 'hotelSales',
  });

  return (
    <>
      {hotelSales.map((field, idx) => (
        <React.Fragment key={field.customId}>
          <HotelRescheduleItemCard parentIndex={idx} />
          <Separator gap={16} />
        </React.Fragment>
      ))}
    </>
  );
}
